import { jsonCopy } from '../../../utility/genericUtility';
import { datiGeneraliGenericoInizializzato} from '../componentiBase/sezioniAnagrafica';

export const datiGeneraliGenerico = jsonCopy(datiGeneraliGenericoInizializzato);
